//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { createGlobalStyle } from 'styled-components';

export const UIAShareToastStyles = createGlobalStyle`
  body.modal-open #toast-container.toast-top-right:has(.uia-share-toast) {
    right: ${({ theme }) =>
      `calc(${theme.spacings[2]} + ${theme.spacings[1]})`};
  }
`;
